import { render, staticRenderFns } from "./mat-icon.vue?vue&type=template&id=5654a5c2"
import script from "./mat-icon.ts?vue&type=script&lang=ts&external"
export * from "./mat-icon.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports